/**
 * Left-nav thread list shows chat threads only (notes are not listed as threads).
 *
 * @param {Array<{ id: string, title: string }>} chatThreads
 * @returns {Array<{ id: string, title: string }>}
 */
export function mergeNoteThreadsIntoNavThreads(chatThreads) {
  return chatThreads ?? []
}
